import { categoryPageStore } from '@/stores/category/CategoryPageStore';
import { categoryProductStore } from '@/stores/category/CategoryProductStore';
import type { CategorySearchResultsState } from '@/types/category/CategorySearchTypes';

export function useCategorySearchResultsSync() {
    const pageStore = categoryPageStore();
    const productStore = categoryProductStore();

    const syncQueriedIndex = (results: CategorySearchResultsState | null): void => {
        const index = results?._state?.index;

        if (index === undefined) {
            return;
        }

        productStore.queriedIndex = index;
    };

    const syncAvailableFilters = (results?: CategorySearchResultsState | null): true => {
        const searchResults = results ?? null;
        const orderedFacets = searchResults?.renderingContent?.facetOrdering?.facets?.order;
        const availableFacets = searchResults?._rawResults?.[0]?.facets;

        if (orderedFacets && orderedFacets.length > 0 && productStore.availableFilters.length <= 1) {
            productStore.availableFilters = orderedFacets;
        }

        // Merge regular facets + disjunctive facets (e.g. tags.collection lives in
        // disjunctiveFacets, not in _rawResults[0].facets, due to InstantSearch internals).
        const disjunctiveFacetMap: Record<string, Record<string, number>> = {};

        searchResults?.disjunctiveFacets?.forEach(facet => {
            if (facet.name && facet.data) {
                disjunctiveFacetMap[facet.name] = facet.data;
            }
        });

        const mergedFacets = { ...(availableFacets ?? {}), ...disjunctiveFacetMap };

        if (Object.keys(mergedFacets).length > 0) {
            pageStore.availableFilters = mergedFacets;
        }

        syncQueriedIndex(searchResults);

        const hasResults = (searchResults?._rawResults?.length ?? 0) > 0;

        if (!pageStore.algoliaReady && hasResults) {
            pageStore.algoliaReady = true;
        }

        return true;
    };

    return {
        syncAvailableFilters,
    };
}
